export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4Filters';
export const TEAM_NAME = 'empanada';
